import {useEffect, useRef, useState} from 'react';
import {getTeamRole, type TeamRoleId} from '../src/team';
import './role-icon.css';

export function RoleIcon({roleId, size, decorative = true}: {
  roleId: TeamRoleId; size: 24 | 32 | 48 | 64; decorative?: boolean;
}) {
  const slot = useRef<HTMLSpanElement>(null);
  const [error, setError] = useState<Error | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    let detach: (() => void) | undefined;
    setReady(false);
    void import('./role-icon-renderer').then(({attachRoleIcon}) => {
      if (!mounted || !slot.current) return;
      detach = attachRoleIcon(slot.current, roleId, () => setReady(true), setError);
    }).catch(reason => {
      if (mounted) setError(reason instanceof Error ? reason : new Error(String(reason)));
    });
    return () => {mounted = false; detach?.();};
  }, [roleId, size]);

  // The page error boundary exposes the full error and stack. A failed model is not replaced with another image.
  if (error) throw error;
  return <span ref={slot} className="role-icon"
    role={decorative ? undefined : 'img'} aria-hidden={decorative || undefined}
    aria-label={decorative ? undefined : getTeamRole(roleId).name} aria-busy={!ready}
    style={{width: size, height: size, minWidth: size, maxWidth: 'none', flexShrink: 0}}/>;
}
